module.exports = __webpack_public_path__ + "static/media/logo-telegram.04e083b0.svg";